import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { AddBtn } from '@commonComponents/AddBtn'
import { FormTitle } from '@commonComponents/FormTitle'
const RepeatableItemsContainer = ({
  addItem,
  deleteItem: deleteData,
  updateItem: onChange,
  saveItem: onBlur,
  copyData,
  onSelect,
  maxRowsAllowed = 99,
  translate,
  merchandiseId,
  tableName,
  renderForm,
  title,
  boxNumber,
  additionalComponent,
  isAddDisabled=false
}) => {
  const [toggleAddBtn, setToggleAddBtn] = useState(true)

  const dataSource = useSelector((state) =>
    state.invoiceReducer.invoice.merchandiseMap[merchandiseId][tableName]) || []
  return (
    <div>
      <FormTitle title={title} boxNumber={boxNumber} />
      {additionalComponent}
      {renderForm && dataSource?.length
        ? renderForm({
            deleteData,
            onSelect,
            onChange,
            onBlur,
            dataSource,
            tableName,
            translate,
            copyData,
          })
        : null}
      {dataSource?.length < maxRowsAllowed && (
        <AddBtn
          disabled={(isAddDisabled||!toggleAddBtn||null)}
          onClick={async () => {
            setToggleAddBtn((prev) => !prev)
            const response = await addItem(tableName)
            setToggleAddBtn((prev) => !prev)
          }}
          text={translate('ADD')}
        />
      )}
    </div>
  )
}

export default React.memo(RepeatableItemsContainer)
